import React from "react";
import { Outlet } from "react-router-dom";

export const FrameAuthentication = (): JSX.Element => {
	return (
		<>
			<Outlet />
		</>
	);
};
